import React from 'react';
import { Box, VStack, HStack, Label, Text, Icon } from '@medely/ui-kit';

const NoJobs: React.FC = () => {
  return (
    <Box bgColor="surface.backing-1" borderRadius="8px" p={2} mt={2} width="100%">
      <HStack alignItems="flex-start">
        <Icon
          name="light-lightbulb-exclamation-on"
          variant="custom"
          color="black"
          bgColor="grey.100"
        />
        <VStack gap={0.5} mb={1} ml={1} alignItems="flex-start">
          <Label size="m" color="state.info.primary">
            These roles are in high demand{' '}
          </Label>
          <Text size="s" color="text.primary">
            Finish your onboarding so you don&apos;t miss out!
          </Text>
        </VStack>
      </HStack>
    </Box>
  );
};

export default NoJobs;
